import { AbstractControl, ValidatorFn } from '@angular/forms';

export const matchPassword = (password: string, confirmPassword: string): ValidatorFn => {
    return (formGroup: AbstractControl): { passwordMismatch: boolean } | null => {
        const passwordControl = formGroup.get(password);
        const confirmPasswordControl = formGroup.get(confirmPassword);

        if (!passwordControl || !confirmPasswordControl) {
            return null;
        }
        if (confirmPasswordControl.errors && !confirmPasswordControl.errors[ 'passwordMismatch' ]) {
            return null;
        }
        if (passwordControl.value !== confirmPasswordControl.value) {
            confirmPasswordControl.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        }

        confirmPasswordControl.setErrors(null);
        return null;
    };
};
